:host {
  display: block;
  max-width: 100%;
}

.product-item-content {
  background: transparent;
}

:host([imageAlignment='top']) {
  .product-item-content {
    flex-direction: column;
  }

  .content {
    padding: calc(var(--spacer) * 3) calc(var(--spacer) * 4) 0 calc(var(--spacer) * 4);
  }

  img {
    height: 290px;
  }
}

.count-down {
  display: flex;
  flex-direction: row-reverse;
  left: 0;
  position: absolute;
  height: auto;
}

:host([imageAlignment='right']) {
  .product-item-content {
    flex-direction: row-reverse;
  }

  .content {
    padding: 0 calc(var(--spacer) * 4) calc(var(--spacer) * 4) 0;
    align-self: center;
  }

  .image-container,
  .content {
    width: 50%;
  }

  .container {
    padding: 0 calc(var(--spacer) * 4) 0 calc(var(--spacer) * 4);
    max-width: 1920px;
  }

  .title {
    font-size: var(--header-font-size-xlarge);
  }

  img {
    margin: calc(var(--spacer) * 4) 0 calc(var(--spacer) * 4) 0;
    height: 375px;
  }
}

:host([imageAlignment='left']) {
  .product-item-content {
    flex-direction: row;
  }

  .content {
    padding: 0 0 calc(var(--spacer) * 4) calc(var(--spacer) * 4);
    align-self: center;
  }

  .image-container,
  .content {
    width: 50%;
  }

  img {
    height: 290px;
  }
}

.container {
  padding: 0 calc(var(--spacer) * 2) 0 calc(var(--spacer) * 2);
}

.title {
  padding: 0 0 calc(var(--spacer) * 2) 0;
  color: var(--main-titles-inputs-600);
}

.back {
  display: flex;
  flex-flow: row;
  padding-bottom: calc(var(--spacer) * 5);

  &-btn {
    width: 28px;
    height: 14px;
    box-sizing: border-box;
    font-family: 'Montserrat-Medium', 'Montserrat Medium', 'Montserrat', sans-serif;
    font-weight: 500;
    color: var(--black-layout-700-primary);
    text-align: left;
    line-height: 11px;
    margin-top: 4px;
  }
}

.description {
  padding: 0 0 calc(var(--spacer) * 3) 0;
  line-height: 1.3;
  color: var(--main-titles-inputs-600);
}

.content {
  flex: 0.5 1 auto;
  padding: calc(var(--spacer) * 3) 0 0 0;
}

.image-container {
  flex: 0.5 1 auto;
}

.outer-image-container {
  position: relative;
}

.slot-container {
  display: flex;
  flex-flow: row;
}

::slotted(*) {
  padding: 0 calc(var(--spacer) * 2) 0 0;
}

img {
  width: 100%;
  object-fit: cover;
}
